import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _templateObject;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { urlPath } from "../util/url.js";
export var newApi = function newApi(_ref) {
  var amsResponse = _ref.amsResponse;
  return {
    getCmsPages: function () {
      var _getCmsPages = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return amsResponse.getData({
                method: "GET",
                path: "v1.1/cms/pages"
              });
            case 2:
              data = _context.sent;
              return _context.abrupt("return", data || []);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getCmsPages() {
        return _getCmsPages.apply(this, arguments);
      }
      return getCmsPages;
    }(),
    getCmsPage: function () {
      var _getCmsPage = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
        var pageName, locale, contractType;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              pageName = _ref2.pageName, locale = _ref2.locale, contractType = _ref2.contractType;
              return _context2.abrupt("return", amsResponse.getData({
                method: "GET",
                path: urlPath(_templateObject || (_templateObject = _taggedTemplateLiteral(["v1.1/cms/page/", "/", "/", ""])), pageName, locale, contractType)
              }));
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function getCmsPage(_x) {
        return _getCmsPage.apply(this, arguments);
      }
      return getCmsPage;
    }()
  };
};